import isNumber from "./is-number";
import { getItemFromSession, setItemInSession } from "./session-storage";
/* Utilities to persist and restore scroll position for list pages */

const STORAGE_KEY_PREFIX = "scroll:pos:";

const isBrowser = () => typeof window !== "undefined";

export const getScrollKey = (pathname = "", search = "") => {
    if (!pathname) return "";
    return `${STORAGE_KEY_PREFIX}${pathname}${search || ""}`;
};

export const saveScrollPosition = (key, y = 0) => {
    if (!isBrowser() || !key) return;
    try {
        setItemInSession(key, { y });
    } catch (_e) {
        /* ignore quota / serialization errors */
    }
};

export const restoreScrollPosition = (key) => {
    if (!isBrowser() || !key) return false;
    const stored = getItemFromSession(key);
    if (stored === null || stored === undefined) return false;
    let y;
    if (isNumber(stored)) {
        y = stored;
    } else if (stored && isNumber(stored.y)) {
        y = stored.y;
    } else {
        return false;
    }
    window.scrollTo(0, y);
    return true;
};

